import { useContext } from 'react';
import ExerciseIcon from '@pelckmans/business-components/icons/Exercise';
import ExerciseOutlineIcon from '@pelckmans/business-components/icons/ExerciseOutline';
import FeatureTogglesContext from '../../../../contexts/FeatureTogglesContext';
import { useTranslation } from 'react-i18next';
import ProgressBar from './ProgressBar';

type Props = {
  score?: {
    achieved: number;
    achievable: number;
    maximum: number;
  };
  needsGrading?: boolean;
};

export default function Score({ score, needsGrading }: Props) {
  const featureToggles = useContext(FeatureTogglesContext);
  const { t } = useTranslation();

  return (
    <>
      {score ? <ExerciseIcon /> : <ExerciseOutlineIcon />}
      <div className="material-item__score-panel">
        <div className="material-item__score-content">
          {score ? (
            <>
              <p className="p-mb-1">{t('MODULES.MATERIAL.COMPONENTS.SCORE.RESULT_LABEL')}</p>
              <ProgressBar
                achieved={score.achieved}
                achievable={score.achievable}
                maximum={score.maximum}
                isPending={needsGrading}
              />
              {featureToggles.SHOW_SCORE_DEBUG && (
                <pre data-testid="debug-output">{JSON.stringify(score, null, 2)}</pre>
              )}
            </>
          ) : (
            <span>{t('MODULES.MATERIAL.COMPONENTS.SCORE.NO_RESULT_LABEL')}</span>
          )}
        </div>
      </div>
    </>
  );
}
